import { postAsJson } from "./AbstractService";
import { ConstantesApi } from "@common/utils";

// Shape crudo del API (snake_case). Se mapea a camelCase antes de exponerlo.
const mapRow = (row) => ({
    product: row.product,
    sku: row.sku,
    category: row.category ?? undefined,
    myPrice: row.my_price ?? undefined,
    competitor: row.competitor,
    theirPrice: row.their_price ?? undefined,
    diffPct: row.diff_pct ?? undefined,
    previousPrice: row.previous_price ?? undefined,
    newPrice: row.new_price ?? undefined,
    deltaPct: row.delta_pct ?? undefined,
});

const mapResponse = (data) => ({
    summaryBanner: data.summary_banner ?? undefined,
    supported: data.supported,
    cards: (data.cards ?? []).map((card) => ({
        case: card.case,
        summary: card.summary ?? undefined,
        total: card.total,
        products: (card.products ?? []).map(mapRow),
    })),
});

export const fetchRecommendations = async ({ userId, storeId, module }) => {
    const params = {
        api: ConstantesApi.API_RECOMMENDATIONS,
        data: { userId, storeId, module },
        skipDispatch: true,
    };

    const response = await postAsJson(params);
    // AbstractService traga los errores HTTP y resuelve undefined; degradar a "sin datos".
    if (!response) return { summaryBanner: undefined, supported: false, cards: [] };
    return mapResponse(response);
};
